var React = require('react');

function PlayBold (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.545 12.4704C29.1854 12.811 29.7211 13.3193 30.0946 13.9411C30.4682 14.5628 30.6655 15.2744 30.6655 15.9998C30.6655 16.7251 30.4682 17.4367 30.0946 18.0584C29.7211 18.6802 29.1854 19.1885 28.545 19.5291L11.4623 28.8184C8.71167 30.3158 5.33301 28.3691 5.33301 25.2904V6.71043C5.33301 3.63043 8.71167 1.68509 11.4623 3.17976L28.545 12.4704Z","fill":"white"}));
}

PlayBold.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PlayBold;

PlayBold.default = PlayBold;
